import { useState } from "react"
import { Row } from "react-bootstrap"
import { getActiveProducts } from "../../api/requestAxios/activePackage"
import { CommaSeparator, ToPersianNumber } from "../../functions"
import CustomValuesHook from "../../functions/myHooks/CustomValuesHook"
import { ErrorToast } from "../../shared"
import GSPTable from "../../shared/GSFTable"
import EditPricePackage from "./editPricePackage"
import './style.scss'

const ActivePackage = () => {

  const [infoTabel, setInfoTabel] = useState({
    data: [],
  });

  const [argsTable, setArgsTable] = useState({
    disablePaging: false,
    filterList: [],
    pageNumber: 1,
    whereConditionText: ""
  })


  const [activePackage, setActivePackage] = CustomValuesHook({
    showDetails: false,
    loading: false,
    item: {}
  })


  const optionCompo = ({ item, infoTabel, setInfoTabel }) => {
    return (
      <div>
        <a
          onClick={() => setActivePackage({ showDetails: true, item: item })}
          className="edit-text"
        >ویرایش</a>
      </div>)
  }

  const productTypeCompo = ({ item, infoTabel, setInfoTabel }) => {
    return (
      <div>
        {item.productType === 'IVR' && <span>تلفن گویا</span>}
        {item.productType === 'Fax' && <span>فکس </span>}
        {item.productType === 'Secretary' && <span>منشی</span>}
      </div >
    )
  }

  const extraMinuteCostCompo = ({ item, infoTabel, setInfoTabel }) => {
    return (
      <span>{ToPersianNumber(CommaSeparator(item?.extraMinuteCost))}</span>)
  }

  const monthlyChargeCompo = ({ item, infoTabel, setInfoTabel }) => {
    return (
      <span>{ToPersianNumber(CommaSeparator(item?.monthlyCharge))}</span>)
  }

  const idCompo = ({ item, infoTabel, setInfoTabel }) => {
    return (
      <span>{ToPersianNumber(item?.id)}</span>)
  }



  const handelGetData = async (args) => {
    setActivePackage({ loading: true })
    try {
      if (args) {
        setArgsTable({ ...args })
      }
      const packages = await getActiveProducts(args)
      packages?.data?.data?.forEach((item, index) => {
        item.id = index + 1
      })

      let temp = { ...packages?.data };
      setInfoTabel({ ...temp });

      setActivePackage({ loading: false })

    }
    catch (err) {
      setActivePackage({ loading: false, data: [] })
      ErrorToast(err)
    }
  }

  const columns = [
    { title: 'ردیف', property: 'id', filterProperty: 'null', hasSort: false, hasFilter: false, display: true, component: idCompo },
    { title: 'نوع بسته', property: 'productType', filterProperty: 'null', hasSort: false, hasFilter: false, display: true, component: productTypeCompo },
    { title: 'عنوان بسته', property: 'productName', filterProperty: 'null', hasSort: false, hasFilter: false, display: true },
    { title: 'قیمت ماهانه', property: 'monthlyCharge', filterProperty: 'null', hasSort: false, hasFilter: false, display: true, component: monthlyChargeCompo },
    { title: 'مازاد دقیقه', property: 'extraMinuteCost', filterProperty: 'null', hasSort: false, hasFilter: false, display: true, component: extraMinuteCostCompo },
    { title: 'ویرایش', property: 'fileComponent', filterProperty: 'null', hasSort: false, hasFilter: false, display: true, component: optionCompo },
  ]

  console.log('test***********', infoTabel)

  return (
    <main className="active-package">
      <div className="top-margin"></div>
      <div className="user-info-container user-docs-container">
        <Row className="d-flex flex-row justify-content-start table-packages">
          <GSPTable
            columns={columns}
            hasSorting={false}
            apiCall={handelGetData}
            dataList={infoTabel}
            hasFiltering={false}
            isSearchByExternalBtn={false}
            hasPaging={true}
            enableScrolling={false}
            isStepScrolling={false}
            pageSize={30}
            loading={activePackage?.loading}
          />
        </Row>
        {activePackage?.showDetails && <EditPricePackage
          show={activePackage?.showDetails}
          setShow={setActivePackage}
          item={activePackage?.item}
          handelGetData={handelGetData}
          pageNumber={infoTabel?.pageNumber}
        />}
      </div>
    </main>
  )
}

export default ActivePackage